import { t } from 'i18next';
import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import AccessOpenings from '../../components/AccessOpenings/AccessOpenings';
import ButtonBlackReturn from '../../components/Buttons/ButtonBlackReturn'
import { CustomAlert } from '../../components/CustomAlert/CustomAlert';
import AccessOpeningContext from '../../context/AccessOpeningContext/AccessOpeningContext';
import { getTenantInfoByKey, getUserOpening, havePermission } from '../../helpers/helpers';
import { logout } from '../../services/login';

const SelectAccessOpening = () => {

    const { accessOpeningState, getAccessOpenings, setAccessOpening } = useContext(AccessOpeningContext);
    const { accessOpenigs, isFetching, error, message } = accessOpeningState;

    const navigate = useNavigate();

    const canMakeAccess = havePermission(1);

    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');

    const haveSelectAnOpening = getUserOpening();

    const handleSelectOpening = (opening) => {
        setAccessOpening(opening);
        navigate('/selectAccessBuildings')
    }

    useEffect(() => {
        if (haveSelectAnOpening) navigate('/selectAccessBuildings');
        if (canMakeAccess === true && haveAccessOpenings === true) getAccessOpenings()
        else handleSelectOpening({ codigo: '', descripcion: t('NO_OPENING') })
        // eslint-disable-next-line
    }, [])

    return (
        <div className='pe-4 ps-4'>
            {
                isFetching ?
                    <div className="d-flex mt-5 justify-content-center">
                        <Spinner />
                    </div>
                    :
                    <div>
                        <ButtonBlackReturn
                            onClick={logout}
                            title={`${t('CHOOSE_OPENING')} ${getTenantInfoByKey('opening_name')}`}
                        />
                        <div className='mt-3'>
                            {error ? <CustomAlert color={'danger'} text={message} /> : null}
                            <AccessOpenings
                                accessOpenigs={accessOpenigs}
                                selectOpening={handleSelectOpening}
                            />
                        </div>
                    </div>
            }
        </div>
    )
}

export default SelectAccessOpening